export var CHANNEL_NAME = 'embedded-confluence-iframe';
export var PASSTHROUGH_PROPS_MODULE_NAME = 'passThroughProps';
export var PROPS_UPDATED = 'propsUpdated';
export var EXPERIENCE_FORWARDING_MODULE_NAME = 'experienceForwarding';